import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import SEO from '../../seo';
import Title from '../../General/Title';
import PageAnimation from '../../App/PageAnimation';

const Template = styled.div`
  width: 100%;
`;

const PageTemplate = ({ children, seo, title }) => {
  return (
    <PageAnimation>
      <Template>
        <SEO title={seo} />
        {title && title !== '' && <Title text={title} />}
        {children}
      </Template>
    </PageAnimation>
  );
};

PageTemplate.propTypes = {
  children: PropTypes.node.isRequired,
  seo: PropTypes.string.isRequired,
  title: PropTypes.string,
};

PageTemplate.defaultProps = {
  title: '',
};

export default PageTemplate;
